<template>
    <div id="cuestionario_respuestas">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                Capacitación # {{ Comision.idComision }} - {{ Comision.Nombre }}
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">


                <!-- Respuestas Primer Intento -->
                <el-col :xs="24" :sm="12">
                    <div style="margin-top:30px; border:1px solid #ccc; padding:30px; font-size:18px; background-color:rgba(255,255,255,0.3)">
                        <center><strong>Preguntas Contestadas</strong></center><br>
                        <hr>
                        <div v-if="Intento1">
                            <ol>
                                <li v-for="(item,index) in Intento1" :key="index">
                                    <span :class="'color-' + item.Tipo">{{ item.Pregunta }}</span>
                                </li>
                            </ol>
                            <hr>
                            <small><i>{{ Correctas1 }} / 7 Respuestas Correctas.</i></small>
                            <hr>                    
                            <center><strong>{{ Estado1 }}</strong></center>
                        </div>
                        <span v-if="!Intento1" style="font-style:italic">No se Registran Respuestas.<br></span>
                    </div>
                </el-col>


                <!-- Respuestas Segundo Intento -->
                <el-col :xs="24" :sm="12">
                    <div style="margin-top:30px; border:1px solid #ccc; padding:30px; font-size:18px; background-color:rgba(255,255,255,0.3)">
                        <center><strong>Preguntas Contestadas Recuperación</strong></center><br>
                        <hr>
                        <div v-if="Intento2">
                            <ol>
                                <li v-for="(item,index) in Intento2" :key="index">
                                    <span :class="'color-' + item.Tipo">{{ item.Pregunta }}</span>
                                </li>
                            </ol>
                            <hr>
                            <small><i>{{ Correctas2 }} / 7 Respuestas Correctas.</i></small>
                            <hr>
                            <center><strong>{{ Estado2 }}</strong></center>
                        </div>
                        <span v-if="!Intento2" style="font-style:italic">No se Registran Respuestas.<br></span>
                    </div>
                </el-col>


                <el-col :span="24">
                    <center>
                        <router-link class="el-button el-button--info" :to="{ name: 'cuestionarios' }" style="margin-top:50px; width:50%">
                            Volver
                        </router-link>
                    </center>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>



<script>
    import axios from 'axios'

    export default
    {   data()
        {   return {
                idComisionEncriptada:   this.$route.params.id,
                idComision:             atob(this.$route.params.id),
                Comision:               [],
                Intento1:               [],
                Intento2:               [],
                Estado1:                '',
                Estado2:                '',
                Correctas1:             0,
                Correctas2:             0,
            }
        },


        methods:
        {   SumarRespuestasCorrectas(arreglo)
            {   var suma = 0;
                if(arreglo)
                {   for(var i=0; i<arreglo.length; i=i+1)
                    {   if(arreglo[i].Tipo==1)
                            suma = suma + 1;                
                    }
                }
                return suma;
            },    
        },


        beforeMount( )
        {   if (!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = '';
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                params = params + 'tkn=' + this.$cookies.get('PDTK');
                params = params + '&idComision=' + this.idComisionEncriptada;
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/quest_dt.php', params, {headers: headers})
                    .then(response => {
                        const datos             = response.data
                        this.Comision           = datos['Comision'];
                        this.Intento1           = datos['Intento1'];
                        this.Intento2           = datos['Intento2'];                        
                        this.Correctas1         = this.SumarRespuestasCorrectas(this.Intento1);
                        this.Correctas2         = this.SumarRespuestasCorrectas(this.Intento2);
                        if(this.Correctas1>=5)  this.Estado1 = 'Aprobado';
                        else                    this.Estado1 = 'Desaprobado';
                        if(this.Correctas2>=5)  this.Estado2 = 'Aprobado';
                        else                    this.Estado2 = 'Desaprobado';
                        if(!this.Comision)      this.$router.push('/cuestionarios');
                    })
                    /*.catch(e => {})*/
            }
        }
    };
</script>



<style>
    .color-0
    {   font-weight: bold;
        color: red;
    }
    
    .color-1
    {   font-weight: bold;
        color: green;
    }
</style>